import { render, staticRenderFns } from "./pubdataset.vue?vue&type=template&id=5734ebac&"
import script from "./pubdataset.vue?vue&type=script&lang=js&"
export * from "./pubdataset.vue?vue&type=script&lang=js&"
import style0 from "./pubdataset.vue?vue&type=style&index=0&id=5734ebac&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports